export const request = (options = {}) => {
  const { $http } = useNuxtApp();
  // 统一处理 header 和 headers，$fetch 使用 headers（复数形式）
  if (options.header && !options.headers) {
    options.headers = options.header;
    delete options.header;
  }
  // 统一处理 data 和 body，$fetch 使用 body
  if (options.data && !options.body) {
    options.body = options.data;
    delete options.data;
  }
  return $http(options.url, options);
};
